<script>
import moment from "moment/moment";

export default {
    props: ['post'],
    template: document.getElementById('post-card-html').innerHTML,
    methods: {
        formatDate(date, format) {
            return moment(date).lang('EN').format(format);
        },
        formatEventDate(startDate, endDate) {
            let startDay = ''
            let startMonth = '';
            let startYear = ''
            if (startDate) {
                startDay = moment(startDate).lang(this.$store.state.curLang).format('DD');
                startMonth = moment(startDate).lang(this.$store.state.curLang).format('MMMM');
                startYear = moment(startDate).lang(this.$store.state.curLang).format('YYYY');
            }

            let endDay = '';
            let endMonth = '';
            if (endDate) {
                endDay = moment(endDate).lang(this.$store.state.curLang).format('DD');
                endMonth = moment(endDate).lang(this.$store.state.curLang).format('MMMM');
            }

            // Day(s)
            let returnDateString = startDay;
            if (endDay && startDay !== endDay) {
                returnDateString += '-' + endDay;
            }

            // Month(s)
            if (startMonth === endMonth) {
                returnDateString += ' ' + startMonth;
            } else {
                returnDateString += ' ' + startMonth + '/' + endMonth;
            }

            // Year
            if (startYear) {
                returnDateString += ' ' + startYear;
            }


            return returnDateString;
            // formatDate(post.date, 'MMMM DD, YYYY')
        }
    }
}
</script>
